import { api } from '@/store/service';

const InitialState = {
  isLoading: false,
  list: [],
  pathList: {},
};

const mutations = {
  setLoading(state, isLoading) {
    return Object.assign(state, { isLoading });
  },
  update(state, list) {
    return Object.assign(state, { list });
  },
  updateList(oldState, list) {
    const path = [];
    list.forEach((element) => {
      if (element.children) {
        // add parents path
        element.children.forEach((parent) => {
          if (parent.menu_path.src_code) path.push(`/${parent.menu_path.src_code}`);
          if (parent.children) {
            // add children path
            parent.children.forEach((child) => {
              if (child.menu_path.src_code) path.push(`/${child.menu_path.src_code}`);
            });
          }
        });
      }
    });
    const newState = oldState;
    newState.pathList = path.reduce((acum, current) => {
      const prev = acum;
      prev[current] = true;
      return prev;
    }, {});
    return newState;
  },
};

const actions = {
  async list({ commit }) {
    try {
      commit('setLoading', true);
      const list = await api('get', 'v2/profiles/menu');
      commit('update', list);
      commit('updateList', list);
      commit('setLoading', false);
    } catch (error) {
      console.log(error);
      commit('setLoading', false);
      throw error;
    }
  },
};

const getters = {
  menu: (state) => state.list,
};

export default {
  state: InitialState,
  mutations,
  actions,
  getters,
  namespaced: true,
};
